import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=111b3007&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=111b3007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b3007",
  null
  
)

export default component.exports